import { useState, useMemo, useCallback } from 'react';
import {
  Paper,
  TextField,
  Button,
  Typography,
  Autocomplete,
  Card,
  CardContent,
  CardActionArea,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Chip,
  Alert,
  Snackbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  LinearProgress,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  CircularProgress,
  Divider,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import SendIcon from '@mui/icons-material/Send';
import SmsIcon from '@mui/icons-material/Sms';
import RouterIcon from '@mui/icons-material/Router';
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';
import HistoryIcon from '@mui/icons-material/History';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import InfoIcon from '@mui/icons-material/Info';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import TuneIcon from '@mui/icons-material/Tune';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import TimerIcon from '@mui/icons-material/Timer';
import StorageIcon from '@mui/icons-material/Storage';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import SimCardIcon from '@mui/icons-material/SimCard';
// Ícones adicionais para comandos
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import MemoryIcon from '@mui/icons-material/Memory';
import SpeedIcon from '@mui/icons-material/Speed';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import WifiIcon from '@mui/icons-material/Wifi';
import BluetoothIcon from '@mui/icons-material/Bluetooth';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import FlashOffIcon from '@mui/icons-material/FlashOff';
import BuildIcon from '@mui/icons-material/Build';
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import WarningIcon from '@mui/icons-material/Warning';
import UpdateIcon from '@mui/icons-material/Update';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import PauseIcon from '@mui/icons-material/Pause';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import NightlightIcon from '@mui/icons-material/Nightlight';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import AvTimerIcon from '@mui/icons-material/AvTimer';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventIcon from '@mui/icons-material/Event';
import PhoneIcon from '@mui/icons-material/Phone';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import KeyIcon from '@mui/icons-material/Key';
import SettingsIcon from '@mui/icons-material/Settings';
import DnsIcon from '@mui/icons-material/Dns';
import LanguageIcon from '@mui/icons-material/Language';
import PublicIcon from '@mui/icons-material/Public';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import ExploreIcon from '@mui/icons-material/Explore';
import MapIcon from '@mui/icons-material/Map';
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';
import CellTowerIcon from '@mui/icons-material/CellTower';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import SyncIcon from '@mui/icons-material/Sync';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ErrorIcon from '@mui/icons-material/Error';
import HelpIcon from '@mui/icons-material/Help';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import VideocamIcon from '@mui/icons-material/Videocam';
import MicIcon from '@mui/icons-material/Mic';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import VibrationIcon from '@mui/icons-material/Vibration';
import SensorsIcon from '@mui/icons-material/Sensors';
import SensorsOffIcon from '@mui/icons-material/SensorsOff';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import GppGoodIcon from '@mui/icons-material/GppGood';
import GppBadIcon from '@mui/icons-material/GppBad';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import EngineeringIcon from '@mui/icons-material/Engineering';
import ConstructionIcon from '@mui/icons-material/Construction';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/PowerOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import PreviewIcon from '@mui/icons-material/Preview';
import { useEffectAsync, useCatch } from '../../reactHelper';

// SMS API - usando proxy para evitar CORS (mesmo endpoint do ConfiguratorPage)
const SMS_API_URL = '/sms-api';

// Sanitiza número de telefone para envio (remove caracteres especiais, adiciona DDI se necessário)
const sanitizePhone = (phone, defaultDdi = '55') => {
  if (!phone) return '';
  // Remove tudo exceto dígitos
  let cleaned = phone.replace(/\D/g, '');

  // Se o número tem 10 ou 11 dígitos (DDD + número), adiciona DDI
  // 10 dígitos = telefone fixo (DDD 2 + número 8)
  // 11 dígitos = celular (DDD 2 + 9 + número 8)
  if (cleaned.length === 10 || cleaned.length === 11) {
    cleaned = defaultDdi + cleaned;
  }

  return cleaned;
};

// ============================================================================
// FALLBACK DATA (usado quando API não disponível)
// ============================================================================

const FALLBACK_TEMPLATES = {
  teltonika: {
    brand: 'Teltonika',
    model: 'FMB/FMC/FMM',
    protocol: 'teltonika',
    port: 5027,
    smssupport: true,
    gprssupport: true,
    commands: {
      // Básicos
      restart: { name: 'Reiniciar Dispositivo', gprs: 'cpureset', sms: 'cpureset', description: 'Reinicia o dispositivo completamente' },
      status: { name: 'Status Geral', gprs: 'getinfo', sms: 'getinfo', description: 'Obtém informações do dispositivo' },
      position: { name: 'Posição GPS Atual', gprs: 'getgps', sms: 'getgps', description: 'Solicita posição GPS atual' },
      // Configuração de Rede
      apn: { name: 'Configurar APN', gprs: 'setparam 2001:{apn}', sms: 'setparam 2001:{apn}', params: ['apn'], description: 'Define apenas a APN' },
      apnFull: { name: 'APN com Usuário/Senha', gprs: 'setparam 2001:{apn};2002:{apn_user};2003:{apn_pass}', sms: 'setparam 2001:{apn};2002:{apn_user};2003:{apn_pass}', params: ['apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      server: { name: 'Servidor e Porta', gprs: 'setparam 2004:{server};2005:{port}', sms: 'setparam 2004:{server};2005:{port}', params: ['server', 'port'], description: 'Define servidor e porta' },
      // Intervalo
      interval: { name: 'Intervalo de Envio', gprs: 'setparam 1002:{interval}', sms: 'setparam 1002:{interval}', params: ['interval'], description: 'Define intervalo em segundos' },
      intervalStop: { name: 'Intervalo Parado', gprs: 'setparam 10050:{interval}', sms: 'setparam 10050:{interval}', params: ['interval'], description: 'Intervalo quando veículo parado' },
      // Bloqueio
      block: { name: 'Bloquear Motor', gprs: 'setdigout 1', sms: 'setdigout 1', description: 'Ativa saída digital 1' },
      unblock: { name: 'Desbloquear Motor', gprs: 'setdigout 0', sms: 'setdigout 0', description: 'Desativa saída digital 1' },
      // Avançados
      odometer: { name: 'Configurar Odômetro', gprs: 'setparam 65:{km}', sms: 'setparam 65:{km}', params: ['km'], description: 'Define odômetro em metros' },
      timezone: { name: 'Fuso Horário', gprs: 'setparam 1020:{offset}', sms: 'setparam 1020:{offset}', params: ['offset'], description: 'Define timezone (ex: -3 para Brasília)' },
      sleepMode: { name: 'Modo Sleep', gprs: 'setparam 1000:{mode}', sms: 'setparam 1000:{mode}', params: ['mode'], description: 'Define modo sleep (0=desabilitado)' },
      firmware: { name: 'Versão Firmware', gprs: 'getver', sms: 'getver', description: 'Obtém versão do firmware' },
      params: { name: 'Ver Parâmetros', gprs: 'readparam 1002,2001,2004,2005', sms: 'readparam 1002,2001,2004,2005', description: 'Lê parâmetros principais' },
    },
  },
  coban: {
    brand: 'Coban',
    model: 'TK103/GPS103',
    protocol: 'gps103',
    port: 5001,
    smssupport: true,
    gprssupport: true,
    commands: {
      // Básicos
      restart: { name: 'Reiniciar Dispositivo', sms: 'reset123456', description: 'Reinicia o dispositivo' },
      status: { name: 'Status Geral', sms: 'check123456', description: 'Verifica status do dispositivo' },
      position: { name: 'Posição GPS Atual', sms: 'fix001s***n123456', description: 'Solicita posição atual' },
      // Configuração de Rede
      apn: { name: 'Configurar APN', sms: 'apn123456 {apn}', params: ['apn'], description: 'Define apenas a APN' },
      apnFull: { name: 'APN com Usuário/Senha', sms: 'apn123456 {apn} {apn_user} {apn_pass}', params: ['apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      server: { name: 'Servidor e Porta', sms: 'adminip123456 {server} {port}', params: ['server', 'port'], description: 'Define servidor e porta' },
      // Bloqueio
      block: { name: 'Bloquear Motor', sms: 'stop123456', description: 'Bloqueia o motor' },
      unblock: { name: 'Desbloquear Motor', sms: 'resume123456', description: 'Desbloqueia o motor' },
      // Alertas
      overspeed: { name: 'Alerta Velocidade', sms: 'speed123456 {velocidade}', params: ['velocidade'], description: 'Define limite de velocidade (km/h)' },
      sosNumber: { name: 'Número SOS', sms: 'admin123456 {numero}', params: ['numero'], description: 'Define número para alertas SOS' },
      // Avançados
      timezone: { name: 'Fuso Horário', sms: 'timezone123456 {zona}', params: ['zona'], description: 'Define fuso horário (ex: -3)' },
      password: { name: 'Alterar Senha', sms: '123456 password {nova_senha}', params: ['nova_senha'], description: 'Altera senha do dispositivo' },
      gprsMode: { name: 'Modo GPRS', sms: 'gprs123456', description: 'Ativa modo GPRS (desliga SMS)' },
      smsMode: { name: 'Modo SMS', sms: 'sms123456', description: 'Ativa modo SMS' },
      alarm: { name: 'Ativar Alarme', sms: 'arm123456', description: 'Ativa alarme do veículo' },
      disarm: { name: 'Desativar Alarme', sms: 'disarm123456', description: 'Desativa alarme do veículo' },
    },
  },
  gt06: {
    brand: 'Concox',
    model: 'GT06/JM/WeTrack',
    protocol: 'gt06',
    port: 5023,
    smssupport: true,
    gprssupport: true,
    commands: {
      // Básicos
      restart: { name: 'Reiniciar Dispositivo', sms: 'RESET#', description: 'Reinicia o dispositivo' },
      factory: { name: 'Restaurar Fábrica', sms: 'FACTORY#', description: 'Restaura configurações de fábrica' },
      status: { name: 'Status Geral', sms: 'STATUS#', description: 'Verifica status' },
      position: { name: 'Posição GPS Atual', sms: 'WHERE#', description: 'Solicita posição atual' },
      // Configuração de Rede
      apn: { name: 'Configurar APN', sms: 'APN,{apn}#', params: ['apn'], description: 'Define apenas a APN' },
      apnFull: { name: 'APN com Usuário/Senha', sms: 'APN,{apn},{apn_user},{apn_pass}#', params: ['apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      serverIp: { name: 'Servidor por IP', sms: 'SERVER,0,{ip},{port},0#', params: ['ip', 'port'], description: 'Define servidor por IP' },
      serverDns: { name: 'Servidor por DNS', sms: 'SERVER,1,{server},{port},0#', params: ['server', 'port'], description: 'Define servidor por DNS' },
      // Bloqueio
      block: { name: 'Bloquear Motor', sms: 'RELAY,1#', description: 'Ativa relé (bloqueio)' },
      unblock: { name: 'Desbloquear Motor', sms: 'RELAY,0#', description: 'Desativa relé' },
      // Intervalo
      intervalMove: { name: 'Intervalo Movendo', sms: 'TIMER,{segundos}#', params: ['segundos'], description: 'Intervalo quando movendo' },
      intervalStop: { name: 'Intervalo Parado', sms: 'SENDS,{segundos}#', params: ['segundos'], description: 'Intervalo quando parado' },
      // Alertas
      overspeed: { name: 'Alerta Velocidade', sms: 'SPEED,{velocidade}#', params: ['velocidade'], description: 'Define limite de velocidade' },
      timezone: { name: 'Fuso Horário', sms: 'GMT,W,{horas},{minutos}#', params: ['horas', 'minutos'], description: 'Define fuso (W=oeste)' },
      // Telefone
      sosNumber: { name: 'Número SOS', sms: 'SOS,A,{numero}#', params: ['numero'], description: 'Define número SOS' },
      adminPhone: { name: 'Telefone Admin', sms: 'CENTER,A,{numero}#', params: ['numero'], description: 'Define telefone administrador' },
      // Modo
      gprsMode: { name: 'Modo GPRS', sms: 'GPRSSET,1#', description: 'Ativa modo GPRS' },
      sleepMode: { name: 'Modo Sleep', sms: 'SLEEP,{modo}#', params: ['modo'], description: 'Define modo sleep (0-3)' },
      // Senha
      password: { name: 'Alterar Senha', sms: 'PASSWORD,{antiga},{nova}#', params: ['antiga', 'nova'], description: 'Altera senha do dispositivo' },
    },
  },
  sinotrack: {
    brand: 'Sinotrack',
    model: 'ST-901/ST-906',
    protocol: 'h02',
    port: 5013,
    smssupport: true,
    gprssupport: true,
    commands: {
      // Básicos
      restart: { name: 'Reiniciar Dispositivo', sms: 'RESET#', description: 'Reinicia o dispositivo' },
      factory: { name: 'Restaurar Fábrica', sms: 'FACTORY#', description: 'Restaura configurações de fábrica' },
      status: { name: 'Status Geral', sms: 'STATUS#', description: 'Verifica status' },
      position: { name: 'Posição GPS Atual', sms: 'WHERE#', description: 'Solicita localização atual' },
      // Configuração de Rede
      apn: { name: 'Configurar APN', sms: 'APN,{apn}#', params: ['apn'], description: 'Define apenas a APN' },
      apnFull: { name: 'APN com Usuário/Senha', sms: 'APN,{apn},{apn_user},{apn_pass}#', params: ['apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      server: { name: 'Servidor e Porta', sms: 'IP,{server},{port}#', params: ['server', 'port'], description: 'Define servidor e porta' },
      // Bloqueio
      block: { name: 'Bloquear Motor', sms: 'RELAY,1#', description: 'Ativa relé (bloqueio)' },
      unblock: { name: 'Desbloquear Motor', sms: 'RELAY,0#', description: 'Desativa relé' },
      // Intervalo
      intervalGps: { name: 'Intervalo GPS', sms: 'TIMER,{segundos}#', params: ['segundos'], description: 'Intervalo de coleta GPS' },
      intervalUpload: { name: 'Intervalo Upload', sms: 'UPLOAD,{segundos}#', params: ['segundos'], description: 'Intervalo de envio' },
      // Alertas
      overspeed: { name: 'Alerta Velocidade', sms: 'SPEED,{velocidade}#', params: ['velocidade'], description: 'Define limite de velocidade' },
      sosNumber: { name: 'Número SOS', sms: 'SOS1,{numero}#', params: ['numero'], description: 'Define número SOS principal' },
      // Modo
      timezone: { name: 'Fuso Horário', sms: 'GMT,W,{horas}#', params: ['horas'], description: 'Define fuso horário' },
      sleepMode: { name: 'Modo Economia', sms: 'SLEEP,{modo}#', params: ['modo'], description: 'Define modo sleep' },
      shockAlert: { name: 'Alerta Vibração', sms: 'SHAKE,{sensibilidade}#', params: ['sensibilidade'], description: 'Define sensibilidade (1-10)' },
    },
  },
  queclink: {
    brand: 'Queclink',
    model: 'GV/GL/GMT',
    protocol: 'gl200',
    port: 5004,
    smssupport: true,
    gprssupport: true,
    commands: {
      // Básicos
      restart: { name: 'Reiniciar Dispositivo', sms: 'AT+GTRTO=gl200,3,,,,,,FFFF$', description: 'Reinicia o dispositivo' },
      factory: { name: 'Restaurar Fábrica', sms: 'AT+GTRTO=gl200,4,,,,,,FFFF$', description: 'Restaura configurações de fábrica' },
      status: { name: 'Status Geral', sms: 'AT+GTINF=gl200,,,,,,,FFFF$', description: 'Obtém informações do dispositivo' },
      position: { name: 'Posição GPS Atual', sms: 'AT+GTRTO=gl200,1,,,,,,FFFF$', description: 'Solicita posição GPS atual' },
      // Configuração de Rede
      apn: { name: 'Configurar APN', sms: 'AT+GTBSI=gl200,{apn},,,,,,FFFF$', params: ['apn'], description: 'Define apenas a APN' },
      apnFull: { name: 'APN com Usuário/Senha', sms: 'AT+GTBSI=gl200,{apn},{apn_user},{apn_pass},,,,FFFF$', params: ['apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      server: { name: 'Servidor e Porta', sms: 'AT+GTSRI=gl200,,,{server},{port},,,,,,FFFF$', params: ['server', 'port'], description: 'Define servidor e porta' },
      // Bloqueio
      block: { name: 'Bloquear Motor', sms: 'AT+GTOUT=gl200,1,0,0,0,0,0,0,0,0,,,,,FFFF$', description: 'Ativa saída (bloqueio)' },
      unblock: { name: 'Desbloquear Motor', sms: 'AT+GTOUT=gl200,0,0,0,0,0,0,0,0,0,,,,,FFFF$', description: 'Desativa saída' },
      // Intervalo
      intervalFix: { name: 'Intervalo GPS', sms: 'AT+GTFRI=gl200,1,1,1,{segundos},0,,,,,,,,,,FFFF$', params: ['segundos'], description: 'Intervalo de fix GPS' },
      // Avançados
      firmware: { name: 'Versão Firmware', sms: 'AT+GTINF=gl200,0,,,,,,FFFF$', description: 'Obtém versão do firmware' },
      geoFence: { name: 'Ativar Geo-Cerca', sms: 'AT+GTGEO=gl200,{id},1,{lat},{lon},{raio},,,,,,FFFF$', params: ['id', 'lat', 'lon', 'raio'], description: 'Define cerca geográfica' },
      overspeed: { name: 'Alerta Velocidade', sms: 'AT+GTSPD=gl200,1,{velocidade},,,,,,,,,FFFF$', params: ['velocidade'], description: 'Define limite de velocidade' },
    },
  },
  suntech: {
    brand: 'Suntech',
    model: 'ST300/ST340/ST4xx',
    protocol: 'suntech',
    port: 5011,
    smssupport: true,
    gprssupport: true,
    commands: {
      // Básicos
      restart: { name: 'Reiniciar Dispositivo', sms: 'ST300CMD;{imei};02;Reset', params: ['imei'], description: 'Reinicia o dispositivo' },
      status: { name: 'Status Geral', sms: 'ST300CMD;{imei};02;StatusReq', params: ['imei'], description: 'Solicita status' },
      position: { name: 'Posição GPS Atual', sms: 'ST300CMD;{imei};02;Location', params: ['imei'], description: 'Solicita posição atual' },
      // Configuração de Rede
      apnFull: { name: 'APN com Usuário/Senha', sms: 'ST300NTW;{imei};02;{apn};{apn_user};{apn_pass}', params: ['imei', 'apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      server: { name: 'Servidor e Porta', sms: 'ST300SRV;{imei};02;{server};{port}', params: ['imei', 'server', 'port'], description: 'Define servidor e porta' },
      // Bloqueio
      block: { name: 'Bloquear Motor', sms: 'ST300CMD;{imei};02;Enable Out1', params: ['imei'], description: 'Ativa saída 1 (bloqueio)' },
      unblock: { name: 'Desbloquear Motor', sms: 'ST300CMD;{imei};02;Disable Out1', params: ['imei'], description: 'Desativa saída 1' },
      // Intervalo
      intervalMove: { name: 'Intervalo Movendo', sms: 'ST300RPT;{imei};02;{segundos}', params: ['imei', 'segundos'], description: 'Intervalo quando movendo' },
      // Avançados
      output2On: { name: 'Ligar Saída 2', sms: 'ST300CMD;{imei};02;Enable Out2', params: ['imei'], description: 'Ativa saída digital 2' },
      output2Off: { name: 'Desligar Saída 2', sms: 'ST300CMD;{imei};02;Disable Out2', params: ['imei'], description: 'Desativa saída digital 2' },
      sirenOn: { name: 'Ligar Sirene', sms: 'ST300CMD;{imei};02;Buzzer On', params: ['imei'], description: 'Ativa buzzer/sirene' },
      sirenOff: { name: 'Desligar Sirene', sms: 'ST300CMD;{imei};02;Buzzer Off', params: ['imei'], description: 'Desativa buzzer/sirene' },
    },
  },
  meitrack: {
    brand: 'Meitrack',
    model: 'T/MVT/TC',
    protocol: 'meitrack',
    port: 5020,
    smssupport: true,
    gprssupport: true,
    commands: {
      // Básicos
      restart: { name: 'Reiniciar Dispositivo', sms: '0000,A12', description: 'Reinicia o dispositivo' },
      factory: { name: 'Restaurar Fábrica', sms: '0000,F01', description: 'Restaura configurações de fábrica' },
      status: { name: 'Status Geral', sms: '0000,A10', description: 'Solicita status' },
      position: { name: 'Posição GPS Atual', sms: '0000,A00', description: 'Solicita localização' },
      // Configuração de Rede
      apnFull: { name: 'APN com Usuário/Senha', sms: '0000,B91,{apn},{apn_user},{apn_pass}', params: ['apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      server: { name: 'Servidor e Porta', sms: '0000,B35,0,{server},{port}', params: ['server', 'port'], description: 'Define servidor e porta' },
      // Bloqueio
      block: { name: 'Bloquear Motor', sms: '0000,C01,0,1', description: 'Ativa saída (bloqueio)' },
      unblock: { name: 'Desbloquear Motor', sms: '0000,C01,0,0', description: 'Desativa saída' },
      // Intervalo
      intervalMove: { name: 'Intervalo Movendo', sms: '0000,B04,{segundos}', params: ['segundos'], description: 'Intervalo quando movendo' },
      intervalStop: { name: 'Intervalo Parado', sms: '0000,B05,{segundos}', params: ['segundos'], description: 'Intervalo quando parado' },
      // Alertas
      overspeed: { name: 'Alerta Velocidade', sms: '0000,B06,{velocidade}', params: ['velocidade'], description: 'Define limite de velocidade' },
      sosNumber: { name: 'Número SOS', sms: '0000,A71,{numero}', params: ['numero'], description: 'Define número SOS' },
      // Avançados
      password: { name: 'Alterar Senha', sms: '0000,A01,{nova_senha}', params: ['nova_senha'], description: 'Altera senha do dispositivo' },
      firmware: { name: 'Versão Firmware', sms: '0000,A21', description: 'Obtém versão do firmware' },
    },
  },
  ruptela: {
    brand: 'Ruptela',
    model: 'FM/Pro/HCV',
    protocol: 'ruptela',
    port: 5046,
    smssupport: true,
    gprssupport: true,
    commands: {
      // Básicos
      restart: { name: 'Reiniciar Dispositivo', sms: ' reset', description: 'Reinicia o dispositivo' },
      status: { name: 'Status Geral', sms: ' getinfo', description: 'Solicita informações' },
      position: { name: 'Posição GPS Atual', sms: ' getgps', description: 'Solicita localização' },
      // Configuração de Rede
      apnFull: { name: 'APN com Usuário/Senha', sms: ' setparam 104:{apn};105:{apn_user};106:{apn_pass}', params: ['apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      server: { name: 'Servidor e Porta', sms: ' setparam 100:{server};101:{port}', params: ['server', 'port'], description: 'Define servidor e porta' },
      // Bloqueio
      block: { name: 'Bloquear Motor', sms: ' setdigout 1', description: 'Ativa saída digital' },
      unblock: { name: 'Desbloquear Motor', sms: ' setdigout 0', description: 'Desativa saída digital' },
      // Intervalo
      intervalMove: { name: 'Intervalo Movendo', sms: ' setparam 107:{segundos}', params: ['segundos'], description: 'Intervalo quando movendo' },
      intervalStop: { name: 'Intervalo Parado', sms: ' setparam 108:{segundos}', params: ['segundos'], description: 'Intervalo quando parado' },
      // Avançados
      readParams: { name: 'Ler Parâmetros', sms: ' getparam 100,101,104,105,106', description: 'Lê parâmetros de rede' },
      firmware: { name: 'Versão Firmware', sms: ' getver', description: 'Obtém versão do firmware' },
    },
  },
  // === FABRICANTES ADICIONAIS ===
  topin: {
    brand: 'Topin/ZX',
    model: 'ZX303/ZX612/G51',
    protocol: 'topin',
    port: 5199,
    smssupport: true,
    gprssupport: true,
    commands: {
      restart: { name: 'Reiniciar Dispositivo', sms: 'RESET#', description: 'Reinicia o dispositivo' },
      factory: { name: 'Restaurar Fábrica', sms: 'FACTORY#', description: 'Restaura configurações' },
      position: { name: 'Posição GPS Atual', sms: 'URL#', description: 'Recebe link do Google Maps' },
      apnFull: { name: 'APN com Usuário/Senha', sms: 'APN,{apn},{apn_user},{apn_pass}#', params: ['apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      server: { name: 'Servidor e Porta', sms: 'IP,{server},{port}#', params: ['server', 'port'], description: 'Define servidor e porta' },
      sosNumber: { name: 'Número SOS', sms: 'SOS,{numero}#', params: ['numero'], description: 'Define número SOS' },
      timezone: { name: 'Fuso Horário', sms: 'TZ,W,{horas}#', params: ['horas'], description: 'Define fuso horário' },
    },
  },
  h02: {
    brand: 'H02/Genérico',
    model: 'Clones Chineses',
    protocol: 'h02',
    port: 5013,
    smssupport: true,
    gprssupport: true,
    commands: {
      restart: { name: 'Reiniciar Dispositivo', sms: 'RESET#', description: 'Reinicia o dispositivo' },
      position: { name: 'Posição GPS Atual', sms: 'WHERE#', description: 'Solicita posição' },
      status: { name: 'Status Geral', sms: 'STATUS#', description: 'Verifica status' },
      apnFull: { name: 'APN com Usuário/Senha', sms: 'APN,{apn},{apn_user},{apn_pass}#', params: ['apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      server: { name: 'Servidor e Porta', sms: 'IP,{server},{port}#', params: ['server', 'port'], description: 'Define servidor e porta' },
      block: { name: 'Bloquear Motor', sms: 'RELAY,1#', description: 'Ativa relé' },
      unblock: { name: 'Desbloquear Motor', sms: 'RELAY,0#', description: 'Desativa relé' },
      interval: { name: 'Intervalo de Envio', sms: 'TIMER,{segundos}#', params: ['segundos'], description: 'Define intervalo' },
      overspeed: { name: 'Alerta Velocidade', sms: 'SPEED,{velocidade}#', params: ['velocidade'], description: 'Define limite de velocidade' },
    },
  },
  tk103: {
    brand: 'TK103',
    model: 'TK103A/B/C',
    protocol: 'tk103',
    port: 5002,
    smssupport: true,
    gprssupport: true,
    commands: {
      restart: { name: 'Reiniciar Dispositivo', sms: 'reset123456', description: 'Reinicia o dispositivo' },
      position: { name: 'Posição GPS Atual', sms: 'fix001s***n123456', description: 'Solicita posição' },
      status: { name: 'Status Geral', sms: 'check123456', description: 'Verifica status' },
      apnFull: { name: 'APN com Usuário/Senha', sms: 'apn123456 {apn} {apn_user} {apn_pass}', params: ['apn', 'apn_user', 'apn_pass'], description: 'Define APN completa' },
      server: { name: 'Servidor e Porta', sms: 'adminip123456 {server} {port}', params: ['server', 'port'], description: 'Define servidor e porta' },
      block: { name: 'Bloquear Motor', sms: 'stop123456', description: 'Bloqueia o motor' },
      unblock: { name: 'Desbloquear Motor', sms: 'resume123456', description: 'Desbloqueia o motor' },
      overspeed: { name: 'Alerta Velocidade', sms: 'speed123456 {velocidade}', params: ['velocidade'], description: 'Define limite (km/h)' },
      timezone: { name: 'Fuso Horário', sms: 'timezone123456 {zona}', params: ['zona'], description: 'Define fuso (ex: -3)' },
      arm: { name: 'Ativar Alarme', sms: 'arm123456', description: 'Ativa alarme' },
      disarm: { name: 'Desativar Alarme', sms: 'disarm123456', description: 'Desativa alarme' },
    },
  },
};

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

// ============================================================================
// MAPEAMENTO DE ÍCONES PARA COMANDOS
// Sistema híbrido: palavras-chave → ícone + cor
// ============================================================================
const COMMAND_ICON_MAP = [
  // === REINICIAR / RESET ===
  { keywords: ['reiniciar', 'reset', 'restart', 'reboot', 'reinicio'], icon: RestartAltIcon, color: 'warning.main' },

  // === LIGAR / DESLIGAR ===
  { keywords: ['ligar', 'power on', 'turn on', 'ativar'], icon: PowerIcon, color: 'success.main' },
  { keywords: ['desligar', 'power off', 'turn off', 'shutdown', 'desativar'], icon: PowerOffIcon, color: 'error.main' },

  // === BLOQUEIO DE MOTOR ===
  { keywords: ['bloquear', 'block', 'cortar', 'cut', 'stop', 'imobilizar', 'immobilize'], icon: LockIcon, color: 'error.main' },
  { keywords: ['desbloquear', 'unblock', 'religar', 'resume', 'liberar', 'release'], icon: LockOpenIcon, color: 'success.main' },

  // === LOCALIZAÇÃO / GPS ===
  { keywords: ['posição', 'position', 'localização', 'location', 'where', 'onde'], icon: MyLocationIcon, color: 'secondary.main' },
  { keywords: ['gps', 'satelite', 'satellite', 'gnss'], icon: SatelliteAltIcon, color: 'info.main' },
  { keywords: ['rastrear', 'track', 'tracking', 'rastreamento'], icon: ExploreIcon, color: 'primary.main' },
  { keywords: ['mapa', 'map', 'rota', 'route'], icon: MapIcon, color: 'primary.main' },

  // === CONFIGURAÇÃO DE REDE ===
  { keywords: ['servidor', 'server', 'ip', 'dns', 'host'], icon: DnsIcon, color: 'primary.main' },
  { keywords: ['apn', 'chip', 'simcard', 'sim'], icon: SimCardIcon, color: 'info.main' },
  { keywords: ['porta', 'port', 'tcp', 'udp'], icon: CellTowerIcon, color: 'primary.main' },
  { keywords: ['rede', 'network', 'gprs', '4g', '3g', '2g', 'lte'], icon: SignalCellularAltIcon, color: 'info.main' },
  { keywords: ['wifi', 'wireless', 'hotspot'], icon: WifiIcon, color: 'info.main' },
  { keywords: ['bluetooth', 'bt'], icon: BluetoothIcon, color: 'info.main' },

  // === STATUS / INFO ===
  { keywords: ['status', 'estado', 'state'], icon: InfoIcon, color: 'info.main' },
  { keywords: ['info', 'informação', 'information', 'dados', 'data'], icon: InfoIcon, color: 'info.main' },
  { keywords: ['diagnóstico', 'diagnostic', 'check', 'verificar', 'test'], icon: NetworkCheckIcon, color: 'info.main' },
  { keywords: ['versão', 'version', 'firmware', 'software'], icon: MemoryIcon, color: 'secondary.main' },

  // === TEMPO / INTERVALO ===
  { keywords: ['intervalo', 'interval', 'frequência', 'frequency'], icon: AvTimerIcon, color: 'warning.main' },
  { keywords: ['tempo', 'time', 'timer', 'cronômetro'], icon: AccessTimeIcon, color: 'warning.main' },
  { keywords: ['horário', 'schedule', 'agendar', 'agenda'], icon: EventIcon, color: 'warning.main' },
  { keywords: ['atualizar', 'update', 'sincronizar', 'sync'], icon: SyncIcon, color: 'info.main' },

  // === VELOCIDADE / ODÔMETRO ===
  { keywords: ['velocidade', 'speed', 'velocimetro'], icon: SpeedIcon, color: 'warning.main' },
  { keywords: ['odômetro', 'odometer', 'quilometragem', 'mileage', 'km'], icon: SpeedIcon, color: 'info.main' },

  // === ALERTAS / NOTIFICAÇÕES ===
  { keywords: ['alerta', 'alert', 'alarme', 'alarm', 'aviso', 'warning'], icon: NotificationsActiveIcon, color: 'warning.main' },
  { keywords: ['silenciar', 'mute', 'silencioso', 'silent'], icon: NotificationsOffIcon, color: 'action.active' },
  { keywords: ['sirene', 'siren', 'buzzer', 'beep', 'som', 'sound'], icon: VolumeUpIcon, color: 'warning.main' },
  { keywords: ['emergência', 'emergency', 'sos', 'pânico', 'panic'], icon: CrisisAlertIcon, color: 'error.main' },

  // === BATERIA / ENERGIA ===
  { keywords: ['bateria', 'battery', 'carga', 'charge', 'energia', 'power'], icon: BatteryChargingFullIcon, color: 'success.main' },
  { keywords: ['acc', 'ignição', 'ignition', 'chave'], icon: FlashOnIcon, color: 'warning.main' },

  // === SENSORES ===
  { keywords: ['sensor', 'detector', 'detecção'], icon: SensorsIcon, color: 'info.main' },
  { keywords: ['temperatura', 'temp', 'termômetro', 'thermometer'], icon: ThermostatIcon, color: 'warning.main' },
  { keywords: ['combustível', 'fuel', 'gasolina', 'diesel', 'tanque'], icon: LocalGasStationIcon, color: 'warning.main' },
  { keywords: ['vibração', 'vibration', 'movimento', 'motion', 'acelerômetro'], icon: VibrationIcon, color: 'info.main' },

  // === SAÍDAS DIGITAIS ===
  { keywords: ['saída', 'output', 'out', 'relé', 'relay'], icon: ToggleOnIcon, color: 'primary.main' },
  { keywords: ['entrada', 'input', 'in'], icon: ToggleOffIcon, color: 'secondary.main' },
  { keywords: ['digital', 'io', 'gpio'], icon: RadioButtonCheckedIcon, color: 'primary.main' },

  // === CONFIGURAÇÕES ===
  { keywords: ['configurar', 'config', 'setup', 'definir', 'set'], icon: SettingsIcon, color: 'primary.main' },
  { keywords: ['parâmetro', 'parameter', 'param'], icon: TuneIcon, color: 'primary.main' },
  { keywords: ['fábrica', 'factory', 'padrão', 'default', 'restaurar', 'restore'], icon: ConstructionIcon, color: 'warning.main' },
  { keywords: ['salvar', 'save', 'gravar', 'write'], icon: SaveIcon, color: 'success.main' },
  { keywords: ['apagar', 'delete', 'limpar', 'clear', 'erase'], icon: DeleteIcon, color: 'error.main' },

  // === SEGURANÇA ===
  { keywords: ['senha', 'password', 'pass', 'pwd'], icon: VpnKeyIcon, color: 'warning.main' },
  { keywords: ['segurança', 'security', 'proteção', 'protection'], icon: SecurityIcon, color: 'success.main' },
  { keywords: ['admin', 'administrador', 'master'], icon: AdminPanelSettingsIcon, color: 'primary.main' },
  { keywords: ['autorizar', 'authorize', 'permitir', 'allow'], icon: VerifiedUserIcon, color: 'success.main' },

  // === TELEFONE / SMS ===
  { keywords: ['telefone', 'phone', 'número', 'number', 'celular'], icon: PhoneIcon, color: 'info.main' },
  { keywords: ['sms', 'mensagem', 'message', 'texto', 'text'], icon: SmsIcon, color: 'info.main' },
  { keywords: ['contato', 'contact', 'autorizado'], icon: ContactPhoneIcon, color: 'info.main' },

  // === CERCAS / GEOFENCE ===
  { keywords: ['cerca', 'fence', 'geofence', 'zona', 'zone', 'área', 'area'], icon: PublicIcon, color: 'primary.main' },

  // === UPLOAD / DOWNLOAD ===
  { keywords: ['enviar', 'send', 'upload', 'transmitir'], icon: UploadIcon, color: 'primary.main' },
  { keywords: ['receber', 'receive', 'download', 'baixar'], icon: DownloadIcon, color: 'info.main' },
  { keywords: ['log', 'registro', 'histórico', 'history'], icon: HistoryIcon, color: 'secondary.main' },

  // === CÂMERA / MÍDIA ===
  { keywords: ['câmera', 'camera', 'foto', 'photo', 'imagem', 'image'], icon: CameraAltIcon, color: 'secondary.main' },
  { keywords: ['vídeo', 'video', 'gravar', 'record'], icon: VideocamIcon, color: 'secondary.main' },
  { keywords: ['áudio', 'audio', 'microfone', 'mic', 'voz', 'voice'], icon: MicIcon, color: 'secondary.main' },

  // === VEÍCULOS ===
  { keywords: ['carro', 'car', 'veículo', 'vehicle', 'auto'], icon: DirectionsCarIcon, color: 'primary.main' },
  { keywords: ['caminhão', 'truck', 'camionete'], icon: LocalShippingIcon, color: 'primary.main' },
  { keywords: ['moto', 'motorcycle', 'bike', 'motocicleta'], icon: TwoWheelerIcon, color: 'primary.main' },

  // === MODOS ===
  { keywords: ['sleep', 'dormir', 'standby', 'economia'], icon: NightlightIcon, color: 'info.main' },
  { keywords: ['acordar', 'wake', 'wakeup', 'ativo', 'active'], icon: WbSunnyIcon, color: 'warning.main' },
  { keywords: ['voo', 'flight', 'avião', 'airplane', 'aéreo'], icon: AirplanemodeActiveIcon, color: 'info.main' },

  // === MANUTENÇÃO ===
  { keywords: ['manutenção', 'maintenance', 'serviço', 'service'], icon: BuildIcon, color: 'warning.main' },
  { keywords: ['engenharia', 'engineering', 'técnico', 'technical'], icon: EngineeringIcon, color: 'secondary.main' },

  // === ERRO / PROBLEMA ===
  { keywords: ['erro', 'error', 'falha', 'fail', 'problema', 'problem'], icon: ErrorIcon, color: 'error.main' },
  { keywords: ['ajuda', 'help', 'suporte', 'support'], icon: HelpIcon, color: 'info.main' },
];

const getCommandIcon = (commandName, commandKey = '') => {
  const searchText = `${commandName || ''} ${commandKey || ''}`.toLowerCase();

  // Busca o primeiro match nas palavras-chave
  for (const mapping of COMMAND_ICON_MAP) {
    for (const keyword of mapping.keywords) {
      if (searchText.includes(keyword)) {
        const IconComponent = mapping.icon;
        return <IconComponent sx={{ color: mapping.color }} />;
      }
    }
  }

  // Fallback: ícone genérico
  return <TuneIcon sx={{ color: 'action.active' }} />;
};

const parseCommands = (commandsStr) => {
  if (!commandsStr) return null;
  try {
    return typeof commandsStr === 'string' ? JSON.parse(commandsStr) : commandsStr;
  } catch {
    return null;
  }
};

const convertToTemplates = (deviceConfigs) => {
  const templates = {};
  deviceConfigs.forEach((config) => {
    const key = `${config.brand}_${config.model}`.toLowerCase().replace(/[^a-z0-9]/g, '_');
    const commands = parseCommands(config.commands);
    if (commands && Object.keys(commands).length > 0) {
      const commandArray = Object.entries(commands).map(([cmdKey, cmd]) => ({
        key: cmdKey,
        name: cmd.name || cmdKey,
        command: cmd.gprs || cmd.sms || '',
        gprs: cmd.gprs,
        sms: cmd.sms,
        params: cmd.params || extractParams(cmd.gprs || cmd.sms || ''),
        description: cmd.description || '',
      }));
      templates[key] = {
        id: config.id,
        brand: config.brand,
        model: config.model,
        name: `${config.brand} ${config.model}`,
        protocol: config.protocol,
        port: config.port,
        smssupport: config.smssupport,
        gprssupport: config.gprssupport,
        commands: commandArray,
      };
    }
  });
  return templates;
};

const extractParams = (command) => {
  if (!command) return [];
  const matches = command.match(/\{([^}]+)\}/g);
  if (!matches) return [];
  return [...new Set(matches.map((m) => m.slice(1, -1)))];
};

// ============================================================================
// MAIN COMPONENT
// ============================================================================

const CommandsTabV2 = ({ t, smsConfig }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // State
  const [devices, setDevices] = useState([]);
  const [deviceConfigs, setDeviceConfigs] = useState([]);
  const [apnConfigs, setApnConfigs] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [params, setParams] = useState({});
  const [sendViaSms, setSendViaSms] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [commandHistory, setCommandHistory] = useState([]);
  const [usingFallback, setUsingFallback] = useState(false);

  // Create/Edit Command Dialog State
  const [createCommandDialog, setCreateCommandDialog] = useState(false);
  const [editingCommand, setEditingCommand] = useState(null);
  const [newCommand, setNewCommand] = useState({
    name: '',
    description: '',
    sms: '',
    gprs: '',
  });
  const [customCommands, setCustomCommands] = useState(() => {
    // Load custom commands from localStorage
    try {
      const saved = localStorage.getItem('traccar_custom_commands');
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  });

  // Fetch data from APIs
  useEffectAsync(async () => {
    setInitialLoading(true);
    try {
      const [devicesRes, configsRes, apnsRes] = await Promise.all([
        fetch('/api/devices?all=true'),
        fetch('/api/device-config?active=true'),
        fetch('/api/apn-config?active=true'),
      ]);
      if (devicesRes.ok) {
        setDevices(await devicesRes.json());
      }
      if (configsRes.ok) {
        const configs = await configsRes.json();
        setDeviceConfigs(configs);
        setUsingFallback(configs.length === 0);
      } else {
        setUsingFallback(true);
      }
      if (apnsRes.ok) {
        setApnConfigs(await apnsRes.json());
      }
    } catch (e) {
      console.error('Error loading data:', e);
      setUsingFallback(true);
    } finally {
      setInitialLoading(false);
    }
  }, []);

  // Build templates from API or fallback
  const templates = useMemo(() => {
    if (usingFallback || deviceConfigs.length === 0) {
      return Object.entries(FALLBACK_TEMPLATES).reduce((acc, [key, config]) => {
        const commandArray = Object.entries(config.commands).map(([cmdKey, cmd]) => ({
          key: cmdKey,
          name: cmd.name,
          command: cmd.gprs || cmd.sms || '',
          gprs: cmd.gprs,
          sms: cmd.sms,
          params: cmd.params || extractParams(cmd.gprs || cmd.sms || ''),
          description: cmd.description,
        }));
        acc[key] = { ...config, name: `${config.brand} ${config.model}`, commands: commandArray };
        return acc;
      }, {});
    }
    return convertToTemplates(deviceConfigs);
  }, [deviceConfigs, usingFallback]);

  // Auto-detect config from device protocol
  const detectConfig = useCallback((device) => {
    if (!device?.protocol) return null;
    const protocol = device.protocol.toLowerCase();
    const match = Object.entries(templates).find(([, template]) =>
      template.protocol?.toLowerCase() === protocol
    );
    return match ? match[0] : null;
  }, [templates]);

  const handleDeviceChange = (device) => {
    setSelectedDevice(device);
    setSelectedTemplate(null);
    setParams({});
    const detectedKey = detectConfig(device);
    if (detectedKey && templates[detectedKey]) {
      setSelectedConfig(templates[detectedKey]);
    } else {
      setSelectedConfig(null);
    }
  };

  const handleConfigChange = (config) => {
    setSelectedConfig(config);
    setSelectedTemplate(null);
    setParams({});
  };

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    const initialParams = {};
    (template.params || []).forEach((param) => {
      if (param === 'server' && smsConfig?.serverDns) {
        initialParams[param] = smsConfig.serverDns;
      } else if (param === 'ip' && smsConfig?.serverIp) {
        initialParams[param] = smsConfig.serverIp;
      } else if (param === 'port' && selectedConfig?.port) {
        initialParams[param] = String(selectedConfig.port);
      } else {
        initialParams[param] = '';
      }
    });
    setParams(initialParams);
    if (selectedConfig && !selectedConfig.gprssupport && selectedConfig.smssupport) {
      setSendViaSms(true);
    }
  };

  // Handle APN selection from registered APNs
  // Preenche automaticamente {apn}, {apn_user} e {apn_pass}
  const handleApnSelect = (apn) => {
    if (apn && typeof apn === 'object') {
      setParams({
        ...params,
        apn: apn.apnname || '',
        apn_user: apn.apnusername || '',
        apn_pass: apn.apnpassword || '',
      });
    }
  };

  const buildCommand = useMemo(() => {
    if (!selectedTemplate) return '';
    let command = sendViaSms
      ? (selectedTemplate.sms || selectedTemplate.command)
      : (selectedTemplate.gprs || selectedTemplate.command);
    if (!command) return '';
    Object.entries(params).forEach(([key, value]) => {
      command = command.replace(new RegExp(`\\{${key}\\}`, 'g'), value || `{${key}}`);
    });
    return command;
  }, [selectedTemplate, params, sendViaSms]);

  const canSend = useMemo(() => {
    if (!selectedDevice || !selectedTemplate) return false;
    // Check SMS requirements
    if (sendViaSms) {
      if (!selectedDevice.phone) return false;
      if (!smsConfig?.smsApiKey) return false;
    }
    if (!selectedTemplate.params || selectedTemplate.params.length === 0) return true;
    return selectedTemplate.params.every((param) => params[param]?.trim());
  }, [selectedDevice, selectedTemplate, params, sendViaSms, smsConfig]);

  const methodSupported = useMemo(() => {
    if (!selectedConfig) return { sms: true, gprs: true };
    return {
      sms: selectedConfig.smssupport !== false,
      gprs: selectedConfig.gprssupport !== false,
    };
  }, [selectedConfig]);

  // === CREATE/EDIT COMMAND FUNCTIONS ===
  const detectedParams = useMemo(() => {
    const smsParams = extractParams(newCommand.sms);
    const gprsParams = extractParams(newCommand.gprs);
    return [...new Set([...smsParams, ...gprsParams])];
  }, [newCommand.sms, newCommand.gprs]);

  const openCreateCommandDialog = () => {
    setEditingCommand(null);
    setNewCommand({ name: '', description: '', sms: '', gprs: '' });
    setCreateCommandDialog(true);
  };

  const openEditCommandDialog = (command) => {
    setEditingCommand(command);
    setNewCommand({
      name: command.name || '',
      description: command.description || '',
      sms: command.sms || '',
      gprs: command.gprs || command.command || '',
    });
    setCreateCommandDialog(true);
  };

  const handleSaveCommand = () => {
    if (!newCommand.name.trim()) {
      setSnackbar({ open: true, message: t('commandNameRequired') || 'Nome do comando é obrigatório', severity: 'error' });
      return;
    }
    if (!newCommand.sms.trim() && !newCommand.gprs.trim()) {
      setSnackbar({ open: true, message: t('commandTextRequired') || 'Informe o comando SMS ou GPRS', severity: 'error' });
      return;
    }

    const configKey = selectedConfig?.name?.toLowerCase().replace(/[^a-z0-9]/g, '_') || 'custom';
    const commandKey = editingCommand?.key || `custom_${Date.now()}`;

    const commandData = {
      key: commandKey,
      name: newCommand.name.trim(),
      description: newCommand.description.trim(),
      sms: newCommand.sms.trim(),
      gprs: newCommand.gprs.trim(),
      command: newCommand.gprs.trim() || newCommand.sms.trim(),
      params: detectedParams,
      isCustom: true,
    };

    // Save to localStorage
    const updatedCustomCommands = {
      ...customCommands,
      [configKey]: {
        ...(customCommands[configKey] || {}),
        [commandKey]: commandData,
      },
    };

    setCustomCommands(updatedCustomCommands);
    localStorage.setItem('traccar_custom_commands', JSON.stringify(updatedCustomCommands));

    setSnackbar({
      open: true,
      message: editingCommand ? (t('commandUpdated') || 'Comando atualizado!') : (t('commandCreated') || 'Comando criado!'),
      severity: 'success',
    });
    setCreateCommandDialog(false);
    setNewCommand({ name: '', description: '', sms: '', gprs: '' });
    setEditingCommand(null);
  };

  const handleDeleteCustomCommand = (command) => {
    if (!command.isCustom) return;

    const configKey = selectedConfig?.name?.toLowerCase().replace(/[^a-z0-9]/g, '_') || 'custom';
    const updatedConfigCommands = { ...(customCommands[configKey] || {}) };
    delete updatedConfigCommands[command.key];

    const updatedCustomCommands = {
      ...customCommands,
      [configKey]: updatedConfigCommands,
    };

    setCustomCommands(updatedCustomCommands);
    localStorage.setItem('traccar_custom_commands', JSON.stringify(updatedCustomCommands));

    setSnackbar({ open: true, message: t('commandDeleted') || 'Comando excluído!', severity: 'info' });
  };

  // Merge custom commands with selected config
  const mergedCommands = useMemo(() => {
    if (!selectedConfig?.commands) return [];

    const configKey = selectedConfig?.name?.toLowerCase().replace(/[^a-z0-9]/g, '_') || 'custom';
    const configCustomCommands = customCommands[configKey] || {};
    const customCommandArray = Object.values(configCustomCommands);

    return [...selectedConfig.commands, ...customCommandArray];
  }, [selectedConfig, customCommands]);

  const handleSend = useCatch(async () => {
    setConfirmDialog(false);
    setLoading(true);
    try {
      let success = false;
      let errorMessage = '';

      if (sendViaSms) {
        // === ENVIO VIA SMS (API Comtele) ===
        const rawPhone = selectedDevice.phone;
        if (!rawPhone) {
          setSnackbar({ open: true, message: t('smsNoPhoneNumber'), severity: 'error' });
          setLoading(false);
          return;
        }

        // Sanitiza o número removendo caracteres especiais
        const phone = sanitizePhone(rawPhone);
        if (!phone || phone.length < 10) {
          setSnackbar({ open: true, message: t('smsInvalidPhoneNumber'), severity: 'error' });
          setLoading(false);
          return;
        }

        if (!smsConfig?.smsApiKey) {
          setSnackbar({ open: true, message: t('smsConfigureFirst'), severity: 'error' });
          setLoading(false);
          return;
        }

        const response = await fetch(`${SMS_API_URL}/send`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'auth-key': smsConfig.smsApiKey,
          },
          body: JSON.stringify({
            Sender: smsConfig.smsSenderId || 'GPS',
            Receivers: phone,
            Content: buildCommand,
          }),
        });

        const data = await response.json();
        success = data.Success === true;
        errorMessage = data.Message || t('smsUnknownError');

        // Registrar comando enviado no backend (para histórico)
        if (success) {
          try {
            await fetch('/api/sent-commands', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                deviceid: selectedDevice.id,
                command: buildCommand,
                connection: 'sms',
                status: 'sent',
              }),
            });
          } catch (e) {
            console.warn('Failed to log SMS command:', e);
          }
        }
      } else {
        // === ENVIO VIA GPRS (Backend Traccar) ===
        const command = {
          deviceId: selectedDevice.id,
          type: 'custom',
          attributes: { data: buildCommand },
          textChannel: false,
        };
        const response = await fetch('/api/commands/send', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(command),
        });
        success = response.ok;
        if (!success) {
          errorMessage = await response.text();
        }
      }

      if (success) {
        setSnackbar({
          open: true,
          message: sendViaSms ? t('smsCommandSentSms') : t('smsCommandSentGprs'),
          severity: 'success',
        });
        setCommandHistory((prev) => [
          {
            id: Date.now(),
            device: selectedDevice.name,
            config: selectedConfig?.name,
            command: buildCommand,
            viaSms: sendViaSms,
            time: new Date().toISOString(),
          },
          ...prev.slice(0, 9),
        ]);
        setSelectedTemplate(null);
        setParams({});
      } else {
        setSnackbar({ open: true, message: `${t('sharedError')}: ${errorMessage}`, severity: 'error' });
      }
    } finally {
      setLoading(false);
    }
  });

  // Check if template has APN param
  const hasApnParam = selectedTemplate?.params?.includes('apn');

  if (initialLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {/* Data Source Indicator */}
      {usingFallback && (
        <Alert severity="warning" icon={<CloudOffIcon />}>
          {t('configFallbackWarning')}
        </Alert>
      )}
      {!usingFallback && deviceConfigs.length > 0 && (
        <Alert severity="success" icon={<StorageIcon />}>
          {t('configApiLoaded').replace('{count}', deviceConfigs.length)}
        </Alert>
      )}

      {/* Device & Config Selection */}
      <Paper sx={{ p: { xs: 2, sm: 3 }, bgcolor: theme.palette.mode === 'dark' ? 'grey.900' : 'background.paper' }}>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
          <SettingsRemoteIcon color="primary" />
          {t('commandTitle')}
        </Typography>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Autocomplete
              fullWidth
              options={devices}
              getOptionLabel={(option) => `${option.name} (${option.uniqueId})`}
              value={selectedDevice}
              onChange={(_, value) => handleDeviceChange(value)}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderOption={(props, option) => {
                const { key, ...rest } = props;
                return (
                  <Box component="li" key={option.id} {...rest} sx={{ py: 1.5 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                      <Typography variant="body1" fontWeight={500}>
                        {option.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {option.uniqueId} {option.model && `• ${option.model}`} {option.protocol && `• ${option.protocol}`}
                      </Typography>
                    </Box>
                  </Box>
                );
              }}
              renderInput={(inputParams) => (
                <TextField
                  {...inputParams}
                  label={t('deviceTitle')}
                  placeholder={t('sharedSearchDevices')}
                />
              )}
              slotProps={{
                paper: { sx: { minWidth: 450 } },
                listbox: { sx: { maxHeight: 400 } },
              }}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Autocomplete
              fullWidth
              options={Object.values(templates)}
              groupBy={(option) => option.brand}
              getOptionLabel={(option) => option.name || `${option.brand} ${option.model}`}
              value={selectedConfig}
              onChange={(_, value) => handleConfigChange(value)}
              isOptionEqualToValue={(option, value) => option.name === value?.name}
              renderOption={(props, option) => {
                const { key, ...rest } = props;
                return (
                  <Box component="li" key={option.key || option.id} {...rest} sx={{ py: 1.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
                      <SettingsRemoteIcon fontSize="small" color="primary" />
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="body2" fontWeight={500} noWrap>
                          {option.model}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {option.protocol} • {t('sharedPort')}: {option.port}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
                        {option.smssupport && <Chip size="small" label="SMS" color="secondary" variant="outlined" />}
                        {option.gprssupport && <Chip size="small" label="GPRS" color="primary" variant="outlined" />}
                      </Box>
                    </Box>
                  </Box>
                );
              }}
              renderInput={(inputParams) => (
                <TextField
                  {...inputParams}
                  label={t('sharedManufacturer')}
                  placeholder={t('sharedSelect')}
                />
              )}
              slotProps={{
                paper: { sx: { minWidth: 500 } },
                listbox: { sx: { maxHeight: 400 } },
              }}
            />
          </Grid>
        </Grid>

        {/* Selected Config Info */}
        {selectedDevice && selectedConfig && (
          <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Chip icon={<CheckCircleIcon />} label={selectedConfig.name} color="success" variant="outlined" />
            <Chip icon={<RouterIcon />} label={selectedConfig.protocol} color="primary" variant="outlined" size="small" />
            <Chip label={`${t('sharedPort')}: ${selectedConfig.port}`} color="info" size="small" />
            {selectedConfig.smssupport && <Chip icon={<SmsIcon />} label="SMS" size="small" variant="outlined" />}
            {selectedConfig.gprssupport && <Chip icon={<RouterIcon />} label="GPRS" size="small" variant="outlined" />}
          </Box>
        )}
      </Paper>

      {/* Command Templates */}
      {selectedConfig && (
        <Paper sx={{ p: { xs: 2, sm: 3 }, bgcolor: theme.palette.mode === 'dark' ? 'grey.900' : 'background.paper' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, flexWrap: 'wrap', gap: 1 }}>
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {t('commandTemplates')} ({mergedCommands.length})
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddIcon />}
              onClick={openCreateCommandDialog}
              size="small"
            >
              {t('commandCreate') || 'Criar Comando'}
            </Button>
          </Box>

          {mergedCommands.length === 0 ? (
            <Alert severity="info" sx={{ mb: 2 }}>
              {t('commandNoTemplates') || 'Nenhum comando disponível. Clique em "Criar Comando" para adicionar.'}
            </Alert>
          ) : (
            <Grid container spacing={2}>
              {mergedCommands.map((template) => (
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={template.key}>
                  <Card
                    sx={{
                      height: '100%',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      border: 2,
                      borderColor: selectedTemplate?.key === template.key ? 'primary.main' : (template.isCustom ? 'warning.light' : 'transparent'),
                      bgcolor: selectedTemplate?.key === template.key
                        ? (theme.palette.mode === 'dark' ? 'primary.900' : 'primary.50')
                        : (theme.palette.mode === 'dark' ? 'grey.800' : 'grey.50'),
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: theme.shadows[6],
                        borderColor: 'primary.light',
                        bgcolor: theme.palette.mode === 'dark' ? 'grey.700' : 'grey.100',
                      },
                      position: 'relative',
                    }}
                  >
                    {/* Custom Command Actions */}
                    {template.isCustom && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 4,
                          right: 4,
                          display: 'flex',
                          gap: 0.5,
                          zIndex: 1,
                        }}
                      >
                        <Tooltip title={t('sharedEdit') || 'Editar'}>
                          <Button
                            size="small"
                            sx={{ minWidth: 28, p: 0.5 }}
                            onClick={(e) => { e.stopPropagation(); openEditCommandDialog(template); }}
                          >
                            <EditIcon fontSize="small" />
                          </Button>
                        </Tooltip>
                        <Tooltip title={t('sharedRemove') || 'Remover'}>
                          <Button
                            size="small"
                            color="error"
                            sx={{ minWidth: 28, p: 0.5 }}
                            onClick={(e) => { e.stopPropagation(); handleDeleteCustomCommand(template); }}
                          >
                            <DeleteIcon fontSize="small" />
                          </Button>
                        </Tooltip>
                      </Box>
                    )}

                    <CardActionArea onClick={() => handleTemplateSelect(template)} sx={{ height: '100%' }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                          {getCommandIcon(template.name, template.key)}
                          <Typography variant="subtitle2" fontWeight={600} sx={{ flex: 1 }} noWrap>
                            {template.name}
                          </Typography>
                        </Box>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1, minHeight: 40 }}>
                          {template.description}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', alignItems: 'center' }}>
                          {template.gprs && <Chip size="small" label="GPRS" color="primary" variant="outlined" />}
                          {template.sms && <Chip size="small" label="SMS" color="secondary" variant="outlined" />}
                          {template.params?.length > 0 && (
                            <Chip size="small" label={`${template.params.length} param`} variant="outlined" />
                          )}
                          {template.isCustom && (
                            <Chip size="small" label={t('commandCustom') || 'Personalizado'} color="warning" variant="filled" />
                          )}
                        </Box>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </Paper>
      )}

      {/* Parameters & Preview */}
      {selectedTemplate && (
        <Paper sx={{ p: { xs: 2, sm: 3 }, bgcolor: theme.palette.mode === 'dark' ? 'grey.900' : 'background.paper' }}>
          <Typography variant="h6" gutterBottom>
            {t('commandPreview')}
          </Typography>

          {selectedTemplate.params?.length > 0 && (
            <Grid container spacing={2} sx={{ mb: 3 }}>
              {selectedTemplate.params.map((param) => (
                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={param}>
                  {param === 'apn' && apnConfigs.length > 0 ? (
                    <Box>
                      <Autocomplete
                        freeSolo
                        options={apnConfigs}
                        getOptionLabel={(option) => {
                          if (typeof option === 'string') return option;
                          return option.apnname || '';
                        }}
                        inputValue={params[param] || ''}
                        onInputChange={(_, value) => setParams({ ...params, [param]: value })}
                        onChange={(_, value) => handleApnSelect(value)}
                        renderOption={(props, option) => {
                          const { key, ...rest } = props;
                          return (
                            <Box component="li" key={option.id} {...rest} sx={{ py: 1 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                <SimCardIcon fontSize="small" color="primary" />
                                <Box sx={{ flex: 1 }}>
                                  <Typography variant="body2" fontWeight={500}>
                                    {option.apnname}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    {option.operator} • {option.name}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          );
                        }}
                        renderInput={(inputParams) => (
                          <TextField
                            {...inputParams}
                            label="APN"
                            placeholder="Selecione ou digite a APN"
                            helperText={`${apnConfigs.length} APNs cadastradas`}
                          />
                        )}
                        slotProps={{
                          paper: { sx: { minWidth: 350 } },
                          listbox: { sx: { maxHeight: 300 } },
                        }}
                      />
                    </Box>
                  ) : (
                    <TextField
                      label={param.toUpperCase()}
                      value={params[param] || ''}
                      onChange={(e) => setParams({ ...params, [param]: e.target.value })}
                      fullWidth
                      placeholder={
                        param === 'apn' ? 'ex: claro.com.br' :
                        param === 'server' ? 'ex: dns.exemplo.com.br' :
                        param === 'ip' ? 'ex: 123.45.67.89' :
                        param === 'port' ? 'ex: 5027' :
                        param === 'interval' ? 'ex: 60' : ''
                      }
                    />
                  )}
                </Grid>
              ))}
            </Grid>
          )}

          <Box
            sx={{
              bgcolor: theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100',
              color: theme.palette.mode === 'dark' ? 'grey.100' : 'grey.900',
              p: 2,
              borderRadius: 1,
              fontFamily: 'monospace',
              fontSize: '0.95rem',
              wordBreak: 'break-all',
              border: 1,
              borderColor: 'divider',
              mb: 3,
            }}
          >
            {buildCommand || '...'}
          </Box>

          <Divider sx={{ mb: 3 }} />

          <Box>
            <Typography variant="subtitle2" gutterBottom color="text.secondary">
              {t('commandSendMethod')}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
              <ToggleButtonGroup
                value={sendViaSms ? 'sms' : 'gprs'}
                exclusive
                onChange={(_, value) => value && setSendViaSms(value === 'sms')}
                size={isMobile ? 'small' : 'medium'}
              >
                <ToggleButton value="gprs" sx={{ px: 3 }} disabled={!methodSupported.gprs}>
                  <RouterIcon sx={{ mr: 1 }} />
                  GPRS
                </ToggleButton>
                <ToggleButton value="sms" sx={{ px: 3 }} disabled={!methodSupported.sms}>
                  <SmsIcon sx={{ mr: 1 }} />
                  SMS
                </ToggleButton>
              </ToggleButtonGroup>

              <Button
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                startIcon={<SendIcon />}
                onClick={() => setConfirmDialog(true)}
                disabled={!canSend || loading}
              >
                {t('commandSend')}
              </Button>
            </Box>

            <Alert severity={sendViaSms ? 'warning' : 'info'} sx={{ mt: 2 }}>
              {sendViaSms ? t('smsGatewayInfo') : t('commandGprsInfo')}
            </Alert>

            {/* SMS Warnings */}
            {sendViaSms && !selectedDevice?.phone && (
              <Alert severity="error" sx={{ mt: 1 }}>
                {t('smsNoPhoneNumber')}
              </Alert>
            )}
            {sendViaSms && !smsConfig?.smsApiKey && (
              <Alert severity="error" sx={{ mt: 1 }}>
                {t('smsConfigureFirst')}
              </Alert>
            )}
            {sendViaSms && selectedDevice?.phone && smsConfig?.smsApiKey && (
              <Alert severity="success" sx={{ mt: 1 }} icon={<SimCardIcon />}>
                {t('smsTo')}: <strong>{sanitizePhone(selectedDevice.phone)}</strong>
                {selectedDevice.phone !== sanitizePhone(selectedDevice.phone) && (
                  <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    ({t('smsOriginal')}: {selectedDevice.phone})
                  </Typography>
                )}
              </Alert>
            )}
          </Box>
        </Paper>
      )}

      {/* Command History */}
      {commandHistory.length > 0 && (
        <Paper sx={{ p: { xs: 2, sm: 3 }, bgcolor: theme.palette.mode === 'dark' ? 'grey.900' : 'background.paper' }}>
          <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <HistoryIcon color="primary" />
            {t('commandHistory')}
          </Typography>

          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100' }}>
                  <TableCell>{t('reportStartTime')}</TableCell>
                  <TableCell>{t('deviceTitle')}</TableCell>
                  {!isMobile && <TableCell>{t('sharedModel')}</TableCell>}
                  <TableCell>{t('commandTitle')}</TableCell>
                  <TableCell>{t('commandConnection')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {commandHistory.map((item) => (
                  <TableRow key={item.id} hover>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      {new Date(item.time).toLocaleString()}
                    </TableCell>
                    <TableCell>{item.device}</TableCell>
                    {!isMobile && <TableCell>{item.config || '-'}</TableCell>}
                    <TableCell sx={{ maxWidth: 200 }}>
                      <Tooltip title={item.command} arrow>
                        <Typography
                          variant="body2"
                          sx={{
                            fontFamily: 'monospace',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {item.command}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        icon={item.viaSms ? <SmsIcon /> : <RouterIcon />}
                        label={item.viaSms ? 'SMS' : 'GPRS'}
                        color={item.viaSms ? 'secondary' : 'primary'}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}

      {loading && <LinearProgress />}

      {/* Confirm Dialog */}
      <Dialog open={confirmDialog} onClose={() => setConfirmDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{t('commandConfirm')}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            {t('commandConfirmMessage')}
          </DialogContentText>
          <Box
            sx={{
              p: 2,
              bgcolor: theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100',
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" gutterBottom>
              <strong>{t('deviceTitle')}:</strong> {selectedDevice?.name}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <strong>{t('sharedModel')}:</strong> {selectedConfig?.name}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <strong>{t('commandTitle')}:</strong>{' '}
              <code style={{ wordBreak: 'break-all' }}>{buildCommand}</code>
            </Typography>
            <Typography variant="body2">
              <strong>{t('commandConnection')}:</strong> {sendViaSms ? 'SMS' : 'GPRS'}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialog(false)}>{t('sharedCancel')}</Button>
          <Button onClick={handleSend} variant="contained" color="primary">
            {t('commandSend')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Create/Edit Command Dialog */}
      <Dialog
        open={createCommandDialog}
        onClose={() => setCreateCommandDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { bgcolor: theme.palette.mode === 'dark' ? 'grey.900' : 'background.paper' } }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {editingCommand ? <EditIcon color="primary" /> : <AddIcon color="primary" />}
          {editingCommand ? (t('commandEdit') || 'Editar Comando') : (t('commandCreate') || 'Criar Novo Comando')}
        </DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 3 }}>
            {t('commandCreateHelp') || 'Use {chaves} para parâmetros dinâmicos. Ex: {server}, {port}, {apn}, {apn_user}, {apn_pass}'}
          </Alert>

          <Grid container spacing={2}>
            {/* Command Name */}
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                label={t('commandName') || 'Nome do Comando'}
                value={newCommand.name}
                onChange={(e) => setNewCommand({ ...newCommand, name: e.target.value })}
                fullWidth
                required
                placeholder="Ex: Configurar APN"
                helperText={t('commandNameHelp') || 'Nome que aparecerá no card'}
              />
            </Grid>

            {/* Description */}
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                label={t('sharedDescription') || 'Descrição'}
                value={newCommand.description}
                onChange={(e) => setNewCommand({ ...newCommand, description: e.target.value })}
                fullWidth
                placeholder="Ex: Define a APN do chip"
                helperText={t('commandDescHelp') || 'Breve descrição da função'}
              />
            </Grid>

            {/* SMS Command */}
            <Grid size={{ xs: 12 }}>
              <TextField
                label={t('commandSms') || 'Comando SMS'}
                value={newCommand.sms}
                onChange={(e) => setNewCommand({ ...newCommand, sms: e.target.value })}
                fullWidth
                placeholder="Ex: apn123456 {apn} {apn_user} {apn_pass}"
                helperText={t('commandSmsHelp') || 'Comando enviado via SMS. Use {param} para parâmetros.'}
                InputProps={{
                  startAdornment: <SmsIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                  sx: { fontFamily: 'monospace' },
                }}
              />
            </Grid>

            {/* GPRS Command */}
            <Grid size={{ xs: 12 }}>
              <TextField
                label={t('commandGprs') || 'Comando GPRS'}
                value={newCommand.gprs}
                onChange={(e) => setNewCommand({ ...newCommand, gprs: e.target.value })}
                fullWidth
                placeholder="Ex: setparam 2001:{apn}"
                helperText={t('commandGprsHelp') || 'Comando enviado via GPRS/TCP. Use {param} para parâmetros.'}
                InputProps={{
                  startAdornment: <RouterIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                  sx: { fontFamily: 'monospace' },
                }}
              />
            </Grid>

            {/* Detected Parameters */}
            {detectedParams.length > 0 && (
              <Grid size={{ xs: 12 }}>
                <Alert severity="success" icon={<AutoFixHighIcon />}>
                  <Typography variant="subtitle2" gutterBottom>
                    {t('commandDetectedParams') || 'Parâmetros detectados automaticamente:'}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
                    {detectedParams.map((param) => (
                      <Chip
                        key={param}
                        label={`{${param}}`}
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{ fontFamily: 'monospace' }}
                      />
                    ))}
                  </Box>
                </Alert>
              </Grid>
            )}

            {/* Preview */}
            {(newCommand.sms || newCommand.gprs) && (
              <Grid size={{ xs: 12 }}>
                <Paper variant="outlined" sx={{ p: 2, bgcolor: theme.palette.mode === 'dark' ? 'grey.800' : 'grey.50' }}>
                  <Typography variant="subtitle2" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <PreviewIcon fontSize="small" />
                    {t('commandPreview') || 'Preview'}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                    {getCommandIcon(newCommand.name, '')}
                    <Typography variant="body1" fontWeight={600}>
                      {newCommand.name || '(Sem nome)'}
                    </Typography>
                  </Box>
                  {newCommand.description && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      {newCommand.description}
                    </Typography>
                  )}
                  <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                    {newCommand.gprs && <Chip size="small" label="GPRS" color="primary" />}
                    {newCommand.sms && <Chip size="small" label="SMS" color="secondary" />}
                    {detectedParams.length > 0 && (
                      <Chip size="small" label={`${detectedParams.length} param(s)`} variant="outlined" />
                    )}
                  </Box>
                </Paper>
              </Grid>
            )}

            {/* Common Parameters Help */}
            <Grid size={{ xs: 12 }}>
              <Divider sx={{ my: 1 }} />
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                {t('commandCommonParams') || 'Parâmetros comuns:'}
              </Typography>
              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                {[
                  { key: 'server', label: 'Servidor DNS' },
                  { key: 'ip', label: 'IP do servidor' },
                  { key: 'port', label: 'Porta' },
                  { key: 'apn', label: 'Nome da APN' },
                  { key: 'apn_user', label: 'Usuário APN' },
                  { key: 'apn_pass', label: 'Senha APN' },
                  { key: 'interval', label: 'Intervalo (seg)' },
                  { key: 'velocidade', label: 'Velocidade (km/h)' },
                ].map((param) => (
                  <Tooltip key={param.key} title={param.label}>
                    <Chip
                      label={`{${param.key}}`}
                      size="small"
                      variant="outlined"
                      sx={{ fontFamily: 'monospace', cursor: 'pointer' }}
                      onClick={() => {
                        const field = newCommand.sms ? 'sms' : 'gprs';
                        setNewCommand({
                          ...newCommand,
                          [field]: newCommand[field] + ` {${param.key}}`,
                        });
                      }}
                    />
                  </Tooltip>
                ))}
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setCreateCommandDialog(false)}>
            {t('sharedCancel') || 'Cancelar'}
          </Button>
          <Button
            onClick={handleSaveCommand}
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            disabled={!newCommand.name.trim() || (!newCommand.sms.trim() && !newCommand.gprs.trim())}
          >
            {editingCommand ? (t('sharedSave') || 'Salvar') : (t('commandCreate') || 'Criar Comando')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CommandsTabV2;
